import React, { memo } from 'react';
import ToggleTabs from 'src/components/primitives/ToggleTabs/ToggleTabs';
import { ToggleTab } from 'src/components/primitives/ToggleTabs/types';
import { MobileBottomToggleTab } from 'src/components/TradePageGrid/mobile/types';
import { cj } from 'src/utils/classNames';
import { useEffectOnce } from 'react-use';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { Z_INDEX } from 'src/constants/zIndex';

const TABS: ToggleTab<MobileBottomToggleTab>[] = [
	{
		label: 'Trade',
		value: 'trade',
	},
	{
		label: 'Chart',
		value: 'chart',
	},
];

interface Props {
	selectedTab: MobileBottomToggleTab;
	onTabChange: (tab: MobileBottomToggleTab) => void;
	ref: React.RefObject<HTMLDivElement | null>;
}

function TradePageMobileBottomBar({ selectedTab, onTabChange, ref }: Props) {
	const setDriftStore = useDriftStore((s) => s.set);

	// Initialize the active mobile view to "trade".
	useEffectOnce(() => {
		setDriftStore((s) => {
			s.activeMobileView = 'trade';
		});

		return () => {
			setDriftStore((s) => {
				s.activeMobileView = undefined;
			});
		};
	});

	const handleSelectTab = (tab: MobileBottomToggleTab) => {
		onTabChange(tab);

		setDriftStore((s) => {
			s.activeMobileView = tab;
		});
	};

	return (
		<div
			ref={ref}
			className={cj(
				'fixed inset-x-0 bottom-0 flex items-center justify-center',
				'rounded-t-sm border-t border-stroke-divider bg-container-bg px-md py-sm',
				Z_INDEX.mobileBottomBar
			)}
		>
			<ToggleTabs
				options={TABS}
				activeTab={selectedTab}
				onTabChange={handleSelectTab}
				selectedTabClassName="text-text-default"
			/>
		</div>
	);
}

export default memo(TradePageMobileBottomBar);
